"use strict";
/* eslint-disable camelcase */
// @ts-nocheck
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const project_1 = require("../Interfaces/project");
const ColorLibController_1 = __importDefault(require("./ColorLibController"));
const axios_1 = __importDefault(require("axios"));
const Crop_1 = __importDefault(require("@becrop/abstract/Models/Crop"));
const NeedMap_1 = require("@becrop/abstract/Models/NeedMap");
const Score_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Score"));
const Farm_1 = __importDefault(require("@becrop/abstract/Models/Farm"));
const Product_1 = require("../Models/Product");
/* import { fakeFarms } from './fakeCUGFarms'
import { fakeBuilts } from './fakeCUGBuilts'
import { fakeDelivery } from './fakeCUGDelivery'
import { fakeGeodata } from './fakeCUGGeodata' */
class ProjectsController {
    constructor() {
        this.projectsListEndpointURL = '/data/results/map/projects';
        this.comparisonResultEndpointURL = '/data/results/area/comparison';
        this.currentURLString = new URL(window.location.href).searchParams;
        this.maximumDownloadedSingleProjects = 50;
        this.farmsList = [];
        this.last_page = 1;
        this.nextPageInFarmList = 1;
        this.pagesVisitedFarmList = [];
        this.hasProductPermissions = false;
        this.projectsListBuilt = new Array();
        this.projectsListSecondaryBuilt = new Array();
        this.mainSingleProjectDelivery = new project_1.AreaProjectDeliverable({});
        this.mainSingleProjectBuilt = new project_1.AreaProjectBuilt({});
        this.mainSingleMetric = new project_1.BioMetric({}, {});
        this.mainSinglePhChMetric = new project_1.PhChMetric({}, {});
        this.needMap = new NeedMap_1.NeedMap({});
        this.secondarySingleProjectBuilt = new project_1.AreaProjectBuilt({});
        this.secondarySingleProjectDelivery = new project_1.AreaProjectDeliverable({});
        this.secondarySingleMetric = new project_1.BioMetric({}, {});
        this.downloadedSingleProjects = new Array();
        this.compositableProjects = new Array({});
        this.mainHigherMetrics = new Array();
        this.secondaryHigherMetrics = new Array();
        this.mainHigherMetricsBio = new Array();
        this.secondaryHigherMetricsBio = new Array();
        this.mainHigherCategoriesBio = new Array();
        this.secondaryHigherCategoriesBio = new Array();
        this.mainHigherMetricsPhCh = new Array();
        this.secondaryHigherMetricsPhCh = new Array();
        this.mainHigherPhChGeneralInsights = new Array();
        this.secondaryHigherPhChGeneralInsights = new Array();
        this.highlightedComparisonMetric = new project_1.BeCropComparisonMetric({}, {});
        this.highlightedComparisonPhChMetric = new project_1.BeCropComparisonMetric({}, {});
        this.comparisonMetrics = new Array();
        this.multidimensionalComparison = new project_1.MultiDimmensionalComparison({});
        this.comparisonReport = new project_1.ComparisonReport(this.mainHigherMetricsBio, this.secondaryHigherMetricsBio);
        this.farmComparisonState = new Array();
        this.dimension = 'bio';
        this.entityType = 'projects';
        this.isLoadingList = false;
        this.isLoadingMainDelivery = false;
        this.isLoadingSecondaryDelivery = false;
        this.isLoadingComparison = false;
        this.isDobleMode = false;
        this.isSideBySideFarmMode = false;
        this.currentSelectedFarm = null;
        this.products = [];
    }
    async selectFarm(farm) {
        var _a, _b;
        if (farm) {
            this.switchEntityType('farms');
            const myProject = this.findMyProject(farm.id);
            if (myProject) {
                this.renderMainProjectSelected(myProject);
                this.switchEntityType('projects');
            }
            if (farm.fields.length > 0) {
                if (((_b = (_a = farm.fields[0]) === null || _a === void 0 ? void 0 : _a.geodata) === null || _b === void 0 ? void 0 : _b.length) == 0) {
                    await farm.fetchFieldsGeodata();
                }
            }
            /*
                        CONNECTING TO NEW ENDPOINTS -> UI LOADER PENDING
                        if(farm.is_generative_zone) {
                            if(farm.recommendations.length == 0) {
                                await farm.fetchAIGENRecommendations()
                            }
            
                            if(farm.generative_zones.length == 0) {
                                await farm.fetchAIGENStates()
                            }
                        } */
        }
        this.currentSelectedFarm = farm;
    }
    /*     get fakeFarms() {
            return fakeFarms
        }
    
        get fakeBuilts() {
            return fakeBuilts
        }
    
        get fakeDelivery() {
            return fakeDelivery
        } */
    get fakeProducts() {
        return [
            {
                id: 1,
                name: "Pseudomonas fluorescens",
                category: "Microbial",
                subCategory: "Biocontrol",
                portfolio: [
                    { name: "P. fluorescens strain A", dosis: "7,4%" },
                    { name: "PSB Complex", dosis: "9,1%" },
                    { name: "B. bassiana WP", dosis: "11,0%" },
                    { name: "Silicium Forte", dosis: "2,8%" },
                    { name: "Silicium", dosis: "28,8%" },
                    { name: "Forte-F 2", dosis: "0,8%" }
                ]
            },
            {
                id: 2,
                name: "Trichoderma harzianum",
                category: "Microbial",
                subCategory: "Biocontrol",
                portfolio: [
                    { name: "T. harzianum strain T-22", dosis: "5,0%" },
                    { name: "Tricho Power", dosis: "6,5%" },
                    { name: "BioRoot Shield", dosis: "8,0%" },
                    { name: "RootCare Forte", dosis: "3,2%" },
                    { name: "Myco Plus", dosis: "10,5%" },
                    { name: "GreenGuard", dosis: "1,7%" }
                ]
            },
            {
                id: 3,
                name: "Bacillus subtilis",
                category: "Microbial",
                subCategory: "Biocontrol",
                portfolio: [
                    { name: "B. subtilis QST 713", dosis: "4,5%" },
                    { name: "BactiShield", dosis: "7,8%" },
                    { name: "EcoBac", dosis: "9,3%" },
                    { name: "Subtil Pro", dosis: "6,0%" },
                    { name: "Bio Defender", dosis: "3,4%" },
                    { name: "Forte-BS", dosis: "1,2%" }
                ]
            },
            {
                id: 4,
                name: "Azospirillum brasilense",
                category: "Microbial",
                subCategory: "Biofertilizer",
                portfolio: [
                    { name: "AzoBio", dosis: "12,0%" },
                    { name: "N-Fix Plus", dosis: "14,3%" },
                    { name: "RootMax AB", dosis: "9,9%" },
                    { name: "BactoNitro", dosis: "5,6%" },
                    { name: "GreenNitro", dosis: "7,2%" },
                    { name: "Azo Active", dosis: "2,5%" }
                ]
            },
            {
                id: 5,
                name: "Rhizobium leguminosarum",
                category: "Microbial",
                subCategory: "Biofertilizer",
                portfolio: [
                    { name: "R. leguminosarum strain RL200", dosis: "13,5%" },
                    { name: "Nodulizer", dosis: "11,1%" },
                    { name: "RhizoBoost", dosis: "8,7%" },
                    { name: "SymBioFix", dosis: "4,9%" },
                    { name: "NodMax", dosis: "6,8%" },
                    { name: "Legume Forte", dosis: "2,2%" }
                ]
            }
        ];
    }
    async fetchProducts() {
        this.products = [];
        try {
            const request = await fetch(`/recommendations/products/${this.mainSingleProjectDelivery.meta.project_id}`);
            const response = await request.json();
            response.forEach((product) => {
                const productModel = new Product_1.Product({
                    id: product.id,
                    name: product.name,
                    category: product.category,
                    subCategory: product.subCategory,
                    portfolio: product.portfolio
                });
                this.products.push(productModel);
            });
        }
        catch (error) {
            console.log(error);
        }
    }
    async fetchFarmList() {
        try {
            if (this.nextPageInFarmList <= this.last_page && !this.pagesVisitedFarmList.includes(this.nextPageInFarmList)) {
                const request = await fetch(`/farms/api/list?page=${this.nextPageInFarmList}`);
                const response = await request.json();
                response.data.forEach((farm) => {
                    const farmModel = new Farm_1.default({
                        id: farm.id,
                        name: farm.name,
                        client_code: farm.client_code,
                        client_name: farm.client_name,
                        is_generative_zone: farm.is_generative_zone,
                        total_extension: farm.total_extension,
                        total_fields: farm.total_fields,
                        unit: farm.unit,
                        recommendations: farm.recommendations,
                        fields: farm.gis_fields,
                        generative_zones: farm.generative_zone.states,
                    });
                    farmModel.fields.forEach((f) => f.geodata = '');
                    const hasProject = (this.projectsListBuilt.findIndex((a) => a.farm_id === farmModel.id) !== -1) ? true : false;
                    farmModel.hasProject = hasProject;
                    /*
                                    Disconnecting from the old endpoint
                                    if(farmModel.is_generative_zone) {
                                        farmModel.recommendations = []
                                        farmModel.generative_zones = []
                                    } */
                    this.farmsList.push(farmModel);
                });
                this.pagesVisitedFarmList.push(this.nextPageInFarmList);
                this.nextPageInFarmList += 1;
                this.last_page = response.meta.last_page;
            }
            else {
                console.log('No more pages to fetch');
            }
        }
        catch (error) {
            console.log(error);
        }
    }
    get projectIDInURL() {
        return this.currentURLString.get('projectId') || null;
    }
    get areaIDInURL() {
        return this.currentURLString.get('areaId') || null;
    }
    get scale() {
        var _a;
        if (!this.isDobleMode) {
            if (this.mainSingleProjectBuilt.project_type === 'rate') {
                return 'cert';
            }
            else {
                return this.mainSingleMetric.scale;
            }
        }
        else {
            return (_a = this.highlightedComparisonMetric.baseMetric) === null || _a === void 0 ? void 0 : _a.scale;
        }
    }
    switchEntityType(entityKey) {
        this.entityType = entityKey;
        if (entityKey === 'projects') {
            this.selectFarm(null);
        }
        else if (entityKey === 'farms') {
            this.mainSingleProjectDelivery = new project_1.AreaProjectDeliverable({});
            this.mainSingleProjectBuilt = new project_1.AreaProjectBuilt({});
        }
    }
    switchDimension(dimensionKey) {
        this.dimension = dimensionKey;
    }
    setProductPermissions(productLevel) {
        this.hasProductPermissions = (productLevel === 2) ? true : false;
    }
    get hasParams() {
        if (this.projectIDInURL.length > 0 || this.areaIDInURL.length > 0)
            return true;
        return false;
    }
    updateDefaultSecondaryBuilt() {
        if (this.projectsListBuilt.length > 0) {
            const newSecondaryProjectBuiltAmongDownloaded = this.projectsListSecondaryBuilt.find((sp) => sp.area_id !== this.mainSingleProjectBuilt.area_id && sp.downloaded === true);
            if (newSecondaryProjectBuiltAmongDownloaded) {
                this.secondarySingleProjectBuilt = newSecondaryProjectBuiltAmongDownloaded;
            }
            else {
                const newSecondaryProjectBuilt = this.projectsListSecondaryBuilt.find((sp) => sp.area_id !== this.mainSingleProjectBuilt.area_id);
                if (newSecondaryProjectBuilt) {
                    this.secondarySingleProjectBuilt = newSecondaryProjectBuilt;
                }
                else {
                    this.secondarySingleProjectBuilt = this.mainSingleProjectBuilt;
                }
            }
        }
    }
    fillSecondaryList() {
        let secondaryList = this.projectsListBuilt
            .filter((p) => p.project_type === this.mainSingleProjectBuilt.project_type &&
            p.area_crop.id === this.mainSingleProjectBuilt.area_crop.id)
            .map((pr) => pr);
        this.projectsListSecondaryBuilt = secondaryList;
        const currentSecAmongNewList = this.projectsListSecondaryBuilt.findIndex((p) => p === this.secondarySingleProjectBuilt) !== -1
            ? true
            : false;
        if (!currentSecAmongNewList) {
            this.updateDefaultSecondaryBuilt();
        }
    }
    get areEqualProjects() {
        if (this.mainSingleProjectDelivery.meta.type === this.secondarySingleProjectDelivery.meta.type)
            return true;
        return false;
    }
    get areEqualAreas() {
        if (this.mainSingleProjectDelivery.meta.area_id === this.secondarySingleProjectDelivery.meta.area_id)
            return true;
        return false;
    }
    findAmongDownloaded(p, a) {
        const foundProject = this.downloadedSingleProjects.find((dp) => dp.meta.area_id === a && dp.meta.project_id === p);
        if (foundProject) {
            return foundProject;
        }
        else {
            return null;
        }
    }
    addToDownloadedDeliverables(d) {
        if (this.downloadedSingleProjects.length === this.maximumDownloadedSingleProjects) {
            this.downloadedSingleProjects.shift();
        }
        this.downloadedSingleProjects.push(d);
        this.syncAsDownloadedInListBuilt();
    }
    syncAsDownloadedInListBuilt() {
        if (this.downloadedSingleProjects.length > 0) {
            this.projectsListBuilt.forEach((pb) => {
                if (this.findAmongDownloaded(pb.project_id, pb.area_id)) {
                    pb.downloaded = true;
                }
                else {
                    pb.downloaded = false;
                }
            });
        }
    }
    linkSingleBuiltDelivery() {
        if (this.mainSingleProjectDelivery.meta.area_id !== -1 && this.mainSingleProjectDelivery.meta.project_id !== -1) {
            const temSPDIx = this.projectsListBuilt.findIndex((pb) => pb.project_id === this.mainSingleProjectDelivery.meta.project_id &&
                pb.area_id === this.mainSingleProjectDelivery.meta.area_id);
            if (temSPDIx !== -1) {
                this.mainSingleProjectBuilt = this.projectsListBuilt[temSPDIx];
            }
            this.fillSecondaryList();
            this.updateRecommendationsInBuilt();
        }
    }
    async linkSingleMetricDelivery() {
        if (this.mainSingleProjectDelivery) {
            let primaryMetrics = this.mainSingleProjectDelivery.metrics.getPrimaryMetrics();
            if (primaryMetrics.length > 0) {
                this.mainSingleMetric = primaryMetrics[0];
            }
            else {
                let secondaryMetrics = this.mainSingleProjectDelivery.metrics.getSecondaryMetrics();
                if (secondaryMetrics.length > 0) {
                    this.mainSingleMetric = secondaryMetrics[0];
                }
            }
            if (this.mainSingleProjectDelivery.plus.enabled) {
                if (this.mainSingleProjectDelivery.plus.phchMetrics.length > 0) {
                    this.mainSinglePhChMetric = this.mainSingleProjectDelivery.plus.phchMetrics[0];
                }
            }
        }
        if (this.mainSingleMetric.insights.insight.length > 0) {
            this.mainSingleMetricAgInsights = await this.mainSingleProjectDelivery.loadMetricAgInsightsInAllFields(this.mainSingleMetric.code_name);
        }
    }
    updateCompositableProjects() {
        const current = this.mainSingleProjectBuilt;
        if (current.project_type === 'rate') {
            this.compositableProjects = this.projectsListBuilt.filter((pl) => !pl.is_synthetic &&
                pl.area_crop.id === current.area_crop.id &&
                pl.project_type === 'rate' &&
                pl.category === current.category);
        }
        else {
            this.compositableProjects = [];
        }
    }
    setMainProjectSelected(proBuilt) {
        this.mainSingleProjectBuilt = proBuilt;
        this.updateCompositableProjects();
        this.fillSecondaryList();
    }
    setSecondaryProjectSelected(proBuilt) {
        this.secondarySingleProjectBuilt = proBuilt;
    }
    async setMainMetric(met) {
        this.mainSingleMetric = met;
        if (met instanceof project_1.BioMetric) {
            if (met.insights.insight.length > 0) {
                this.mainSingleMetricAgInsights = await this.mainSingleProjectDelivery.loadMetricAgInsightsInAllFields(met.code_name);
            }
        }
    }
    loadPreviousVSMetric(capped, panel) {
        let allMetrics = this.mainHigherMetricsBio;
        if (panel === 'secondary') {
            allMetrics = this.secondaryHigherMetricsBio;
        }
        const allMetricsCurated = allMetrics
            .filter((met) => capped ? met.baseMetric.category.length > 0 : met.baseMetric.category.length > 0)
            .sort((a, b) => b.difference - a.difference);
        const currentMetricIndex = allMetricsCurated.findIndex((m) => m.baseMetric.name === this.highlightedComparisonMetric.baseMetric.name);
        if (currentMetricIndex !== -1) {
            if (currentMetricIndex !== 0) {
                this.setComparisonMetric(allMetricsCurated[currentMetricIndex - 1], panel);
            }
            else {
                this.setComparisonMetric(allMetricsCurated[allMetricsCurated.length - 1], panel);
            }
        }
        else {
            this.setComparisonMetric(allMetricsCurated[0], panel);
        }
    }
    loadPreviousVSPhChMetric(capped, panel) {
        let allMetrics = [...this.mainHigherPhChGeneralInsights, ...this.mainHigherMetricsPhCh];
        if (panel === 'secondary') {
            allMetrics = [...this.secondaryHigherPhChGeneralInsights, ...this.secondaryHigherMetricsPhCh];
        }
        const allMetricsCurated = allMetrics.sort((a, b) => b.difference - a.difference);
        if (allMetricsCurated.length > 0) {
            const currentMetricIndex = allMetricsCurated.findIndex((m) => m.baseMetric.name === this.highlightedComparisonPhChMetric.baseMetric.name &&
                m.baseMetric.test_name === this.highlightedComparisonPhChMetric.baseMetric.test_name);
            if (currentMetricIndex !== -1) {
                if (currentMetricIndex !== 0) {
                    this.setComparisonPhChMetric(allMetricsCurated[currentMetricIndex - 1], panel);
                }
                else {
                    this.setComparisonPhChMetric(allMetricsCurated[allMetricsCurated.length - 1], panel);
                }
            }
        }
    }
    loadPreviousMetric(capped) {
        const allMetrics = this.mainSingleProjectDelivery.metrics.getAllMetrics();
        const allMetricsCurated = allMetrics.filter((met) => capped ? met.category.length > 0 : met.category.length > 0);
        const currentMetricIndex = allMetricsCurated.findIndex((m) => m.name === this.mainSingleMetric.name);
        if (currentMetricIndex !== -1) {
            if (currentMetricIndex !== 0) {
                this.setMainMetric(allMetricsCurated[currentMetricIndex - 1]);
            }
            else {
                this.setMainMetric(allMetricsCurated[allMetricsCurated.length - 1]);
            }
        }
    }
    loadPreviousPhChMetric() {
        const allMetrics = [...this.mainSingleProjectDelivery.plus.generalInsights, ...this.mainSingleProjectDelivery.plus.phchMetrics];
        const allMetricsCurated = allMetrics;
        const currentMetricIndex = allMetricsCurated.findIndex((m) => m.name === this.mainSinglePhChMetric.name &&
            m.test_name === this.mainSinglePhChMetric.test_name);
        if (currentMetricIndex !== -1) {
            if (currentMetricIndex !== 0) {
                this.setMainPhChMetric(allMetricsCurated[currentMetricIndex - 1]);
            }
            else {
                this.setMainPhChMetric(allMetricsCurated[allMetricsCurated.length - 1]);
            }
        }
    }
    loadNextVSMetric(capped, panel) {
        let allMetrics = this.mainHigherMetricsBio;
        if (panel === 'secondary') {
            allMetrics = this.secondaryHigherMetricsBio;
        }
        const allMetricsCurated = allMetrics
            .filter((met) => capped ? met.baseMetric.category.length > 0 : met.baseMetric.category.length > 0)
            .sort((a, b) => b.difference - a.difference);
        const currentMetricIndex = allMetricsCurated.findIndex((m) => m.baseMetric.name === this.highlightedComparisonMetric.baseMetric.name);
        if (currentMetricIndex !== -1) {
            if (currentMetricIndex !== allMetricsCurated.length - 1) {
                this.setComparisonMetric(allMetricsCurated[currentMetricIndex + 1], panel);
            }
            else {
                this.setComparisonMetric(allMetricsCurated[0], panel);
            }
        }
        else {
            this.setComparisonMetric(allMetricsCurated[0], panel);
        }
    }
    loadNextVSPhChMetric(capped, panel) {
        let allMetrics = [...this.mainHigherPhChGeneralInsights, ...this.mainHigherMetricsPhCh];
        if (panel === 'secondary') {
            allMetrics = [...this.secondaryHigherPhChGeneralInsights, ...this.secondaryHigherMetricsPhCh];
        }
        const allMetricsCurated = allMetrics.sort((a, b) => b.difference - a.difference);
        if (allMetricsCurated.length > 0) {
            const currentMetricIndex = allMetricsCurated.findIndex((m) => m.baseMetric.name === this.highlightedComparisonPhChMetric.baseMetric.name &&
                m.baseMetric.test_name === this.highlightedComparisonPhChMetric.baseMetric.test_name);
            if (currentMetricIndex !== -1) {
                if (currentMetricIndex !== allMetricsCurated.length - 1) {
                    this.setComparisonPhChMetric(allMetricsCurated[currentMetricIndex + 1], panel);
                }
                else {
                    this.setComparisonPhChMetric(allMetricsCurated[0], panel);
                }
            }
        }
    }
    loadNextMetric(capped) {
        const allMetrics = this.mainSingleProjectDelivery.metrics.getAllMetrics();
        const allMetricsCurated = allMetrics.filter((met) => capped ? met.category.length > 0 : met.category.length > 0);
        const currentMetricIndex = allMetricsCurated.findIndex((m) => m.name === this.mainSingleMetric.name);
        if (currentMetricIndex !== -1) {
            if (currentMetricIndex !== allMetricsCurated.length - 1) {
                this.setMainMetric(allMetricsCurated[currentMetricIndex + 1]);
            }
            else {
                this.setMainMetric(allMetricsCurated[0]);
            }
        }
    }
    loadNextPhChMetric() {
        const allMetrics = [...this.mainSingleProjectDelivery.plus.generalInsights, ...this.mainSingleProjectDelivery.plus.phchMetrics];
        const allMetricsCurated = allMetrics;
        const currentMetricIndex = allMetricsCurated.findIndex((m) => m.name === this.mainSinglePhChMetric.name &&
            m.test_name === this.mainSinglePhChMetric.test_name);
        if (currentMetricIndex !== -1) {
            if (currentMetricIndex !== allMetricsCurated.length - 1) {
                this.setMainPhChMetric(allMetricsCurated[currentMetricIndex + 1]);
            }
            else {
                this.setMainPhChMetric(allMetricsCurated[0]);
            }
        }
    }
    setMainPhChMetric(met) {
        this.mainSinglePhChMetric = met;
    }
    setSecondaryMetric(met) {
        this.secondarySingleMetric = met;
    }
    setComparisonMetric(met, panel) {
        if (panel === 'main') {
            const tempMetric = this.mainHigherMetrics.find((cm) => cm.baseMetric.code_name == met.baseMetric.code_name);
            if (tempMetric)
                this.highlightedComparisonMetric = tempMetric;
        }
        else {
            const tempMetric = this.secondaryHigherMetrics.find((cm) => cm.baseMetric.code_name === met.baseMetric.code_name);
            if (tempMetric)
                this.highlightedComparisonMetric = tempMetric;
        }
    }
    setComparisonPhChMetric(met, panel) {
        this.highlightedComparisonPhChMetric = met;
    }
    setNeedMap(needMap) {
        this.needMap = needMap;
    }
    updateDimensionAfterProjectUpdate() {
        if (this.isDobleMode) {
            if (!this.mainSingleProjectDelivery.plus.enabled && !this.secondarySingleProjectDelivery.plus.enabled) {
                this.switchDimension('bio');
            }
        }
        else {
            if (!this.mainSingleProjectDelivery.plus.enabled)
                this.switchDimension('bio');
        }
    }
    saveCurrentProjectInDownloads(projectDeliverable) {
        const Ix = this.downloadedSingleProjects.findIndex((dp) => dp.meta.area_id === projectDeliverable.meta.area_id && dp.meta.project_id === projectDeliverable.meta.project_id);
        if (Ix !== -1)
            this.downloadedSingleProjects[Ix] = projectDeliverable;
    }
    async renderMainProjectSelected(proBuilt) {
        this.mainSingleProjectBuilt = proBuilt;
        this.isLoadingMainDelivery = true;
        this.setMainProjectSelected(proBuilt);
        if (proBuilt.polygon.length === 0) {
            await proBuilt.fetchGeodata();
            /*             proBuilt.setGeodata(fakeGeodata.geodata) */
        }
        this.switchEntityType('projects');
        this.needMap = new NeedMap_1.NeedMap({});
        if (this.mainSingleProjectDelivery.meta.area_id !== -1) {
            this.saveCurrentProjectInDownloads(this.mainSingleProjectDelivery);
        }
        await this.loadMainProject(proBuilt);
        //if (this.isDobleMode) await this.fetchComparisonReport();
        this.updateDimensionAfterProjectUpdate();
        this.updateRecommendationsInBuilt();
        if (this.mainSingleProjectDelivery.farmAssociated && this.mainSingleProjectDelivery.farmAssociated.is_generative_zone) {
            this.currentSelectedFarm = this.mainSingleProjectDelivery.farmAssociated;
            /*
                        AIGEN OFF
                        this.setNeedMap(new NeedMap({'slug': 'aigen'})) */
        }
        else {
            const enabledNeedMaps = this.mainSingleProjectDelivery.needsMaps.filter((n) => n.category.enabled);
            if (enabledNeedMaps.length > 0) {
                this.setNeedMap(enabledNeedMaps[0]);
            }
        }
        this.isLoadingMainDelivery = false;
    }
    async renderSecondaryProjectSelected(proBuilt) {
        if (this.secondarySingleProjectDelivery.meta.area_id !== -1) {
            this.saveCurrentProjectInDownloads(this.secondarySingleProjectDelivery);
        }
        await this.fetchComparisonReport();
        this.updateDimensionAfterProjectUpdate();
    }
    updateRecommendationsInBuilt() {
        if (this.mainSingleProjectDelivery.recommendationsFeedback.brief === 'retrieved') {
            if (this.mainSingleProjectDelivery.recommendationsFeedback.set.curatedRecommendations.length > 0) {
                this.mainSingleProjectBuilt.recommendationsNumber = this.mainSingleProjectDelivery.recommendationsFeedback.set.curatedRecommendations.length;
            }
        }
    }
    clearAllComparison() {
        this.mainHigherMetrics = [];
        this.secondaryHigherMetrics = [];
        this.mainHigherMetricsBio = [];
        this.secondaryHigherMetricsBio = [];
        this.mainHigherMetricsPhCh = [];
        this.secondaryHigherMetricsPhCh = [];
        this.multidimensionalComparison = new project_1.MultiDimmensionalComparison({});
    }
    async fetchComparisonReport() {
        this.isLoadingComparison = true;
        const colorController = new ColorLibController_1.default();
        if (this.areEqualProjects) {
            if (!this.areEqualAreas) {
                const url = this.comparisonResultEndpointURL;
                const samplesMainCluster = this.mainSingleProjectDelivery.samples.map((s) => s.code);
                const samplesSecondaryCluster = this.secondarySingleProjectDelivery.samples.map((s) => s.code);
                const clusters = [samplesMainCluster, samplesSecondaryCluster];
                const data = {
                    project_id: this.mainSingleProjectBuilt.project_id,
                    clusters: clusters,
                };
                try {
                    const resp = await axios_1.default.post(url, data);
                    this.clearAllComparison();
                    const panels = ['main', 'secondary'];
                    panels.forEach((p, i) => {
                        resp.data.microbiological[i].forEach((m) => {
                            const storedIx = this.comparisonMetrics.findIndex((cm) => cm.baseMetric.name === m.name && cm.baseMetric.dimension === 'bio');
                            if (storedIx !== -1) {
                                if (!m.difference) {
                                    this.comparisonMetrics[storedIx].samplesDefeated = m.samples.map((s) => new project_1.AreaProjectSamples(s));
                                }
                                else {
                                    this.comparisonMetrics[storedIx].baseMetric.samples = m.samples.map((s) => new project_1.AreaProjectSamples(s));
                                    this.comparisonMetrics[storedIx].baseMetric.score = Math.round(m.score);
                                    this.comparisonMetrics[storedIx].baseMetric.scoreBC.value = Math.round(m.score);
                                    this.comparisonMetrics[storedIx].baseMetric.rank = colorController.getRankFromScore(m.score);
                                    this.comparisonMetrics[storedIx].baseMetric.raw_rank = colorController.getRankFromScore(m.score);
                                    this.comparisonMetrics[storedIx].difference = Math.abs(m.difference);
                                    this.comparisonMetrics[storedIx].higherIn = p;
                                    this.comparisonMetrics[storedIx].scoreDefeated = new Score_1.default(Math.abs(Math.round(m.score - m.difference)));
                                    this.comparisonMetrics[storedIx].rankDefeated = colorController.getRankFromScore(m.score - m.difference);
                                }
                            }
                            else {
                                if (!m.difference) {
                                    this.comparisonMetrics.push(new project_1.BeCropComparisonMetric(new project_1.BioMetric({
                                        name: m.name,
                                        code_name: m.code,
                                        score: Math.round(m.score),
                                        unit: 'BsC',
                                        samples: m.samples.map((s) => new project_1.AreaProjectSamples(s)),
                                        public: m.show_metric,
                                        type_code: m.type_code,
                                        rank: colorController.getRankFromScore(m.score),
                                        rasterUrl: m.rasterUrl
                                    }, {
                                        score: Math.round(m.score),
                                        dimension: 'bio',
                                    }), {
                                        scoreDefeated: new Score_1.default(Math.abs(Math.round(m.score))),
                                        rankDefeated: colorController.getRankFromScore(m.score),
                                        samplesDefeated: m.samples.map((s) => new project_1.AreaProjectSamples(s))
                                    }));
                                }
                                else {
                                    this.comparisonMetrics.push(new project_1.BeCropComparisonMetric(new project_1.BioMetric({
                                        name: m.name,
                                        code_name: m.code,
                                        score: Math.round(m.score),
                                        unit: 'BsC',
                                        samples: m.samples.map((s) => new project_1.AreaProjectSamples(s)),
                                        public: m.show_metric,
                                        type_code: m.type_code,
                                        rank: colorController.getRankFromScore(m.score),
                                        rasterUrl: m.rasterUrl
                                    }, {
                                        score: Math.round(m.score),
                                        dimension: 'bio',
                                    }), {
                                        higherIn: p,
                                        difference: Math.abs(m.difference),
                                        scoreDefeated: new Score_1.default(Math.abs(Math.round(m.score - m.difference))),
                                        rankDefeated: colorController.getRankFromScore(m.score - m.difference)
                                    }));
                                }
                            }
                        });
                    });
                    const tempComparisonFromAll = {
                        microbiological: {
                            higherMain: this.comparisonMetrics.filter((m) => m.higherIn === 'main'),
                            higherSecondary: this.comparisonMetrics.filter((m) => m.higherIn === 'secondary')
                        },
                        phch: {
                            higherMain: {
                                generalInsights: resp.data.phch[0].general_insights.map((m) => new project_1.BeCropComparisonMetric(new project_1.PhChMetric({
                                    name: m.name,
                                    code_name: m.code_name,
                                    unit: m.units,
                                    score: m.value,
                                    rank: (m.rank) ? m.rank : -1,
                                    samples: m.samples.map((s) => new project_1.AreaProjectSamples(s)),
                                    rasterUrl: m.rasterUrl
                                }, {
                                    visual: m.visual,
                                    test_name: m.test_name,
                                    dimension: 'phch'
                                }), {
                                    higherIn: 'main',
                                    difference: m.difference,
                                    scoreDefeated: new Score_1.default(m.value / (1 + (m.difference / 100)), 'phch'),
                                    rankDefeated: -1
                                })),
                                phchMetrics: resp.data.phch[0].metrics.map((m) => new project_1.BeCropComparisonMetric(new project_1.PhChMetric({
                                    name: m.name,
                                    code_name: m.code_name,
                                    unit: m.units,
                                    score: m.value,
                                    rank: (m.rank) ? m.rank : -1,
                                    samples: m.samples.map((s) => new project_1.AreaProjectSamples(s)),
                                    rasterUrl: m.rasterUrl
                                }, {
                                    visual: m.visual,
                                    test_name: m.test_name,
                                    dimension: 'phch'
                                }), {
                                    higherIn: 'main',
                                    difference: m.difference,
                                    scoreDefeated: new Score_1.default(m.value / (1 + (m.difference / 100)), 'phch'),
                                    rankDefeated: -1
                                }))
                            },
                            higherSecondary: {
                                generalInsights: resp.data.phch[1].general_insights.map((m) => new project_1.BeCropComparisonMetric(new project_1.PhChMetric({
                                    name: m.name,
                                    code_name: m.code_name,
                                    unit: m.units,
                                    score: m.value,
                                    rank: (m.rank) ? m.rank : -1,
                                    samples: m.samples.map((s) => new project_1.AreaProjectSamples(s)),
                                    rasterUrl: m.rasterUrl
                                }, {
                                    visual: m.visual,
                                    test_name: m.test_name,
                                    dimension: 'phch'
                                }), {
                                    higherIn: 'secondary',
                                    difference: m.difference,
                                    scoreDefeated: new Score_1.default(m.value / (1 + (m.difference / 100)), 'phch'),
                                    rankDefeated: -1
                                })),
                                phchMetrics: resp.data.phch[1].metrics.map((m) => new project_1.BeCropComparisonMetric(new project_1.PhChMetric({
                                    name: m.name,
                                    code_name: m.code_name,
                                    unit: m.units,
                                    score: m.value,
                                    rank: (m.rank) ? m.rank : -1,
                                    samples: m.samples.map((s) => new project_1.AreaProjectSamples(s)),
                                    rasterUrl: m.rasterUrl
                                }, {
                                    visual: m.visual,
                                    test_name: m.test_name,
                                    dimension: 'phch'
                                }), {
                                    higherIn: 'secondary',
                                    difference: m.difference,
                                    scoreDefeated: new Score_1.default(m.value / (1 + (m.difference / 100)), 'phch'),
                                    rankDefeated: -1
                                }))
                            }
                        }
                    };
                    this.multidimensionalComparison = new project_1.MultiDimmensionalComparison(tempComparisonFromAll);
                    this.mainHigherMetrics =
                        this.multidimensionalComparison.microbiological.higherMain;
                    this.mainHigherMetricsBio =
                        this.multidimensionalComparison.microbiological.higherMain;
                    this.mainHigherMetricsPhCh =
                        this.multidimensionalComparison.phch.higherMain.phchMetrics;
                    this.secondaryHigherMetrics =
                        this.multidimensionalComparison.microbiological.higherSecondary;
                    this.secondaryHigherMetricsBio =
                        this.multidimensionalComparison.microbiological.higherSecondary;
                    this.secondaryHigherMetricsPhCh =
                        this.multidimensionalComparison.phch.higherSecondary.phchMetrics;
                    this.mainHigherPhChGeneralInsights =
                        this.multidimensionalComparison.phch.higherMain.generalInsights;
                    this.secondaryHigherPhChGeneralInsights =
                        this.multidimensionalComparison.phch.higherSecondary.generalInsights;
                    if (this.mainHigherMetrics.length > 0) {
                        this.highlightedComparisonMetric = this.mainHigherMetrics[0];
                    }
                    else {
                        if (this.secondaryHigherMetrics.length > 0) {
                            this.highlightedComparisonMetric = this.secondaryHigherMetrics[0];
                        }
                    }
                    if (this.mainHigherMetricsPhCh.length > 0) {
                        this.highlightedComparisonPhChMetric = this.mainHigherMetricsPhCh[0];
                    }
                    else {
                        if (this.secondaryHigherMetricsPhCh.length > 0) {
                            this.highlightedComparisonPhChMetric = this.secondaryHigherMetricsPhCh[0];
                        }
                    }
                    this.buildComparisonReport();
                    const metricsToAddToMain = [];
                    const metricsToAddToSecondary = [];
                    this.comparisonReport.allMetricsCatalogue.forEach((m) => {
                        if (m.higherIn === 'main') {
                            metricsToAddToMain.push(m.winnerMetric);
                            metricsToAddToSecondary.push(m.defeatedMetric);
                        }
                        if (m.higherIn === 'secondary') {
                            metricsToAddToMain.push(m.defeatedMetric);
                            metricsToAddToSecondary.push(m.winnerMetric);
                        }
                    });
                    this.mainSingleProjectDelivery.addMetricsInFields(metricsToAddToMain);
                    this.secondarySingleProjectDelivery.addMetricsInFields(metricsToAddToSecondary);
                }
                catch (e) {
                    console.log(e.message);
                }
            }
        }
        this.isLoadingComparison = false;
    }
    buildComparisonReport() {
        this.comparisonReport = new project_1.ComparisonReport(this.mainHigherMetricsBio, this.secondaryHigherMetricsBio, this.mainHigherPhChGeneralInsights, this.mainHigherMetricsPhCh, this.secondaryHigherPhChGeneralInsights, this.secondaryHigherMetricsPhCh);
    }
    fillCropsInBuilt() {
        const cropsInvolved = this.mainSingleProjectDelivery.cropsInvolved;
        const builtIx = this.projectsListBuilt.findIndex((pb) => pb.project_id === this.mainSingleProjectDelivery.meta.project_id &&
            pb.area_id === this.mainSingleProjectDelivery.meta.area_id);
        if (builtIx !== -1) {
            this.projectsListBuilt[builtIx].cropsInFields = cropsInvolved;
        }
    }
    async fetchProjectList() {
        this.isLoadingList = true;
        try {
            const request = await fetch(this.projectsListEndpointURL);
            const response = await request.json();
            const rawProjects = response;
            rawProjects.forEach((pr) => {
                pr.gis_areas.forEach((ga) => {
                    this.projectsListBuilt.push(new project_1.AreaProjectBuilt({
                        area_crop: new Crop_1.default({
                            id: ga.meta.crop.id,
                            name: ga.meta.crop.name,
                            icon: ga.meta.crop.logo_name
                        }),
                        area_id: ga.gis_area_id,
                        farm_id: ga.farm_id,
                        area_name: ga.meta.name,
                        extension: ga.meta.extension,
                        extension_units: ga.meta.extension_units,
                        label: ga.meta.name + ' ' + ga.meta.extension + ' ' + pr.project.name + ' ' + pr.project.type,
                        name_project: pr.project.name,
                        project_id: pr.project.id,
                        project_type: pr.project.type,
                        polygon: '',
                        downloaded: false,
                        category: ga.meta.category,
                        is_synthetic: ga.meta.is_synthetic,
                        dateRange: pr.project.sampling_range
                    }));
                });
            });
            this.syncAsDownloadedInListBuilt();
        }
        catch (error) {
            console.error(error);
        }
        this.linkSingleBuiltDelivery();
        this.isLoadingList = false;
    }
    async fetchProject(projectBuilt) {
        var _a, _b;
        const { area_id, project_id } = projectBuilt;
        const projectDeliverableEndpointURL = `/data/results/map/content?gis_area_id=${area_id}&project_id=${project_id}`;
        try {
            const colorController = new ColorLibController_1.default();
            const call = await fetch(projectDeliverableEndpointURL);
            const data = await call.json();
            let plusObj = new project_1.PlusReport({});
            if (data.status === 400) {
                window.location.href = '/dashboard';
            }
            else {
                if (data.plus.length !== 0) {
                    plusObj = new project_1.PlusReport({
                        enabled: true,
                        provider: {
                            name: data.plus.provider.name,
                            logo: data.plus.provider.logo,
                        },
                        phchMetrics: data.plus.metrics.map((m) => new project_1.PhChMetric({
                            "name": m.name,
                            "code_name": m.code_name,
                            "unit": m.units,
                            "score": m.value,
                            "rank": m.rank,
                            "samples": m.samples.map((s) => new project_1.AreaProjectSamples(s)),
                            "rasterUrl": m.rasterUrl
                        }, {
                            "visual": m.visual,
                            "test_name": m.test_name,
                            "dimension": 'phch',
                            "resultOrigin": m.resultOrigin
                        })),
                        generalInsights: data.plus.general_insights.map((g) => new project_1.PhChMetric({
                            "name": g.name,
                            "code_name": g.code_name,
                            "unit": g.units,
                            "score": g.value,
                            "rank": g.rank,
                            "samples": g.samples.map((s) => new project_1.AreaProjectSamples(s)),
                            "rasterUrl": g.rasterUrl
                        }, {
                            "visual": g.visual,
                            "test_name": g.test_name,
                            "dimension": 'phch',
                            "resultOrigin": g.resultOrigin
                        })),
                    });
                }
            }
            const dataFormatted = new project_1.AreaProjectDeliverable({
                meta: {
                    area_id: area_id,
                    project_id: project_id,
                    farm_id: data.area.farm_id,
                    type: data.project.type,
                    name: data.area.name,
                    unit: data.area.unit,
                    extension: data.area.extension,
                    polygon: data.area.geodata,
                    hzones: data.area.hzones,
                    crop: ((_a = data.area) === null || _a === void 0 ? void 0 : _a.crop) ? new Crop_1.default(data.area.crop) : new Crop_1.default({})
                },
                needsMaps: data.need_maps,
                metrics: data.project.type === 'farm' ?
                    new project_1.AreaFarmMetrics(data.metrics) :
                    new project_1.AreaGeneralMetrics(data.metrics),
                certificate: new project_1.AreaCertificate(data.report),
                samples: data.samples.map((s) => new project_1.AreaProjectSamples(s)),
                proposal: data.proposal,
                plus: plusObj,
                gisFields: ((_b = data.area.fields) === null || _b === void 0 ? void 0 : _b.map((field) => new project_1.GisField(field))) || Array(),
                recommendations: data.area.recommendations
            });
            if (data.project.type === 'farm') {
                dataFormatted.farmAssociated = this.findMyFarm(data.area.farm_id);
            }
            return dataFormatted;
        }
        catch (error) {
            console.error(error);
        }
    }
    findMyFarm(id) {
        return this.farmsList.find((f) => f.id === id);
    }
    findMyProject(id) {
        const projBuilt = this.projectsListBuilt.find((p) => p.farm_id === id);
        return projBuilt;
    }
    async loadFirstProject() {
        const projectBuilt = this.projectsListBuilt[0];
        const firstProject = await this.loadProject(projectBuilt);
        return firstProject;
    }
    async loadInitialProject() {
        if (this.mainSingleProjectDelivery.meta.project_id < 0) {
            if (this.hasParams) {
                const project = new project_1.AreaProjectBuilt({
                    project_id: parseInt(this.projectIDInURL),
                    area_id: parseInt(this.areaIDInURL)
                });
                await this.loadMainProject(project);
            }
            else {
                this.mainSingleProjectDelivery = await this.loadFirstProject();
            }
        }
        this.linkSingleBuiltDelivery();
        this.linkSingleMetricDelivery();
        this.updateRecommendationsInBuilt();
        if (this.mainSingleProjectDelivery.farmAssociated && this.mainSingleProjectDelivery.farmAssociated.is_generative_zone) {
            this.currentSelectedFarm = this.mainSingleProjectDelivery.farmAssociated;
            /*
            AIGEN OFF
            this.setNeedMap(new NeedMap({'slug': 'aigen'})) */
        }
        else {
            const enabledNeedMaps = this.mainSingleProjectDelivery.needsMaps.filter((n) => n.category.enabled);
            if (enabledNeedMaps.length > 0) {
                this.setNeedMap(enabledNeedMaps[0]);
            }
            else {
                this.setNeedMap(new NeedMap_1.NeedMap({}));
            }
        }
    }
    async loadProject(projectBuilt) {
        const { area_id, project_id } = projectBuilt;
        const inDownloadsProject = this.findAmongDownloaded(project_id, area_id);
        let myProject = new project_1.AreaProjectDeliverable({});
        if (inDownloadsProject) {
            myProject = inDownloadsProject;
        }
        else {
            const tempProject = await this.fetchProject(projectBuilt);
            if (tempProject) {
                myProject = tempProject;
                this.addToDownloadedDeliverables(myProject);
                const builtIx = this.projectsListBuilt.findIndex((pb) => pb.area_id === projectBuilt.area_id && pb.project_id === projectBuilt.project_id);
                if (builtIx !== -1) {
                    this.projectsListBuilt[builtIx].area_crop = myProject.meta.crop;
                }
            }
        }
        return myProject;
    }
    async loadMainProject(projectBuilt) {
        const { area_id, project_id } = projectBuilt;
        const url = new URL(window.location.href);
        url.searchParams.set('projectId', project_id);
        url.searchParams.set('areaId', area_id);
        window.history.replaceState({}, '', url.href);
        this.isLoadingMainDelivery = true;
        let tempMainProject = new project_1.AreaProjectDeliverable({});
        if (project_id !== undefined && area_id !== undefined) {
            tempMainProject = await this.loadProject(projectBuilt);
        }
        this.mainSingleProjectDelivery = tempMainProject;
        this.linkSingleMetricDelivery();
        if (this.projectsListBuilt.length === 0) {
            this.mainSingleProjectBuilt = new project_1.AreaProjectBuilt({
                project_type: this.mainSingleProjectDelivery.meta.type,
                area_name: this.mainSingleProjectDelivery.meta.name,
                extension: this.mainSingleProjectDelivery.meta.extension,
                extension_units: this.mainSingleProjectDelivery.meta.unit,
                polygon: this.mainSingleProjectDelivery.meta.polygon,
                label: this.mainSingleProjectDelivery.meta.name +
                    ' ' +
                    this.mainSingleProjectDelivery.meta.extension +
                    ' ' +
                    this.mainSingleProjectDelivery.meta.name +
                    ' ' +
                    this.mainSingleProjectDelivery.meta.type,
            });
        }
        this.fillSecondaryList();
        this.isLoadingMainDelivery = false;
    }
    async loadSecondaryProject(projectBuilt) {
        const { area_id, project_id } = projectBuilt;
        this.isLoadingSecondaryDelivery = true;
        let tempSecondaryProject = new project_1.AreaProjectDeliverable({});
        if (project_id !== undefined && area_id !== undefined) {
            tempSecondaryProject = await this.loadProject(projectBuilt);
        }
        this.secondarySingleProjectDelivery = tempSecondaryProject;
        if (this.mainSingleMetric) {
            const metrics = this.secondarySingleProjectDelivery.metrics.getAllMetrics();
            let secondaryMetric = metrics.find((m) => this.mainSingleMetric.code_name === m.code_name);
            if (secondaryMetric) {
                this.setSecondaryMetric(secondaryMetric);
            }
        }
        this.isLoadingSecondaryDelivery = false;
    }
    updateSbSStates() {
        this.farmComparisonState.forEach((p) => {
            p.availableFarms = this.projectsListBuilt.filter((ap) => ap.project_type !== 'rate');
            p.downloadedFarms = this.downloadedSingleProjects;
        });
    }
    deployDobleMode() {
        if (true) {
            this.isDobleMode = false;
            this.isSideBySideFarmMode = true;
            const DEFAULT_NUM_PANELS = 2;
            this.farmComparisonState = [];
            for (let i = 0; i < DEFAULT_NUM_PANELS; i++) {
                const panel = new project_1.SideBySideMapState({
                    farm: this.mainSingleProjectDelivery,
                    availableFarms: this.projectsListBuilt.filter((ap) => {
                        if (ap.project_type !== 'rate') {
                            const forThisAreas = this.projectsListBuilt.filter((apa) => apa.area_id === ap.area_id && apa.project_type !== 'rate');
                            if (forThisAreas.length > 1) {
                                if (ap.project_type === 'farm') {
                                    return true;
                                }
                                else {
                                    return false;
                                }
                            }
                            else {
                                return true;
                            }
                        }
                        else {
                            return false;
                        }
                    }),
                    metric: (this.dimension === 'bio') ?
                        this.mainSingleMetric :
                        (this.mainSinglePhChMetric.code_name !== '000000') ?
                            this.mainSinglePhChMetric : this.mainSingleMetric,
                    availableMetrics: [
                        ...this.mainSingleProjectDelivery.metrics.metricCatalogue,
                        ...this.mainSingleProjectDelivery.plus.metricCatalogue
                    ]
                });
                this.farmComparisonState.push(panel);
            }
        }
        else {
            this.isSideBySideFarmMode = false;
            this.isDobleMode = true;
            this.fetchComparisonReport();
        }
    }
    dismissDobleMode() {
        this.isDobleMode = false;
        this.isSideBySideFarmMode = false;
    }
    setPreviousMainProject() {
        const curatedProjects = this.isDobleMode
            ? this.projectsListBuilt.filter((p) => p.project_type !== 'rate' && p !== this.secondarySingleProjectBuilt)
            : this.projectsListBuilt;
        const curatedProjectsCurrIx = curatedProjects.findIndex((p) => p === this.mainSingleProjectBuilt)(curatedProjectsCurrIx === 0)
            ? this.setMainProjectSelected(curatedProjects[curatedProjects.length - 1])
            : this.setMainProjectSelected(curatedProjects[curatedProjectsCurrIx - 1]);
    }
    setNextMainProject() {
        const curatedProjects = this.isDobleMode
            ? this.projectsListBuilt.filter((p) => p.project_type !== 'rate' && p !== this.secondarySingleProjectBuilt)
            : this.projectsListBuilt;
        const curatedProjectsCurrIx = curatedProjects.findIndex((p) => p === this.mainSingleProjectBuilt)(curatedProjectsCurrIx === curatedProjectsCurrIx.length - 1)
            ? this.setMainProjectSelected(curatedProjects[curatedProjectsCurrIx + 1])
            : this.setMainProjectSelected(curatedProjects[0]);
    }
    setPreviousSecondaryProject() {
        const curatedProjects = this.projectsListSecondaryBuilt.filter((p) => p.project_type !== 'rate' && p !== this.mainSingleProjectBuilt && p.project_type !== 'farm');
        const curatedProjectsCurrIx = curatedProjects.findIndex((p) => p === this.secondarySingleProjectBuilt)(curatedProjectsCurrIx === 0)
            ? this.setSecondaryProjectSelected(curatedProjects[curatedProjects.length - 1])
            : this.setSecondaryProjectSelected(curatedProjects[curatedProjectsCurrIx - 1]);
    }
    setNextSecondaryProject() {
        const curatedProjects = this.projectsListSecondaryBuilt.filter((p) => p.project_type !== 'rate' && p !== this.mainSingleProjectBuilt && p.project_type !== 'farm');
        const curatedProjectsCurrIx = curatedProjects.findIndex((p) => p === this.secondarySingleProjectBuilt)(curatedProjectsCurrIx === curatedProjectsCurrIx.length - 1)
            ? this.setSecondaryProjectSelected(curatedProjects[curatedProjectsCurrIx + 1])
            : this.setSecondaryProjectSelected(curatedProjects[0]);
    }
    manageProjectMetricNavigation(key, panel) {
        if (key === 'ArrowLeft' || key === 'ArrowRight') {
            if (this.isDobleMode) {
                if (panel === 'main') {
                    if (key === 'ArrowLeft') {
                        this.setPreviousMainProject();
                    }
                    if (key === 'ArrowRight') {
                        this.setNextMainProject();
                    }
                }
                if (panel === 'secondary') {
                    if (key === 'ArrowLeft') {
                        this.setPreviousSecondaryProject();
                    }
                    if (key === 'ArrowRight') {
                        this.setNextSecondaryProject();
                    }
                }
            }
            else {
                if (key === 'ArrowLeft') {
                    this.setPreviousMainProject();
                }
                if (key === 'ArrowRight') {
                    this.setNextMainProject();
                }
            }
        }
    }
}
exports.default = ProjectsController;
